// Angular
import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
// RxJS
import { Router } from '@angular/router';
import { FormControl } from '@angular/forms';
import { ReplaySubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { LayoutConfigService } from 'src/app/core/_base/layout/services/layout-config.service';
import { UtilsService } from 'src/app/Services/utils.service';
import { ApiService } from 'src/app/Services/api.service';
import { HtmlClassService } from 'src/app/components/theme/html-class.service';
import { AuthApiService } from 'src/app/components/pages/auth/authApi.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { OtherApiService } from 'src/app/Services/other.service';
import { MatDialog } from '@angular/material/dialog';
import { FeeApiService } from 'src/app/Services/fee.service';
import { ProfileApiService } from 'src/app/Services/profile.service';
import { environment } from 'src/environments/environment';

@Component({
	selector: 'kt-user-profile',
	templateUrl: './user-profile.component.html',
	styleUrls: ['./user-profile.component.scss'],
})
export class UserProfileComponent implements OnInit {
	// Public properties
	entityPreferences = JSON.parse(localStorage.getItem('entityPreferences'));
	@Input() avatar = true;
	@Input() greeting = true;
	@Input() badge: boolean;
	@Input() icon: boolean;

	@Input() iconType: '' | 'warning';

	// Set true to icon as SVG or false as icon class
	@Input() useSVG: boolean;

	// Set bg image path
	@Input() bgImage: string;

	// Set skin color, default to light
	@Input() skin: 'light' | 'dark' = 'light';

	@Input() gridNavSkin: 'light' | 'dark' = 'light';
	User = localStorage.getItem('name');
	logo = localStorage.getItem('logo');
	userPreference = JSON.parse(localStorage.getItem('userPreferences'))
	entityName: string;
	colourTheme: string;
	dropdownAutoClose: any = 'outside';
	session: string;
	userType: string;

	toggleDropdownAutoClose(opened: boolean) {
		this.dropdownAutoClose = opened ? false : 'outside';
	}
	validationForm:FormGroup;
	sessions: any;
	sessionData: any = [];
	selected: string;
	entityGroup: any;
	entityId = localStorage.getItem('entityId')
	selectedEntity: string;
	selectedSession: any = { };
	browserDomain: string;
	qac: string;
	sortBy='name'
	panelOpenState1  = true;
	panelOpenState2  = false;
	forggotPassword = false
	otp: any;
	password: any;
	clientAccessOTPNumbers:any=[]
	validationSwitchForm:FormGroup
	selectedClient:any={}
	showOTP: boolean = false;
	enteredOTP: any;
	selectedEntityData: any={}
	public entityFilterCtrl: FormControl = new FormControl();
	public filteredEntities: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	protected _onDestroy = new Subject<void>();
	placeholder = 'Entity';

	constructor(private router :Router, private layoutConfigService: LayoutConfigService, private service :ProfileApiService,
		private util : UtilsService, private ref : ChangeDetectorRef, private htmlClassService:HtmlClassService,
		private api: AuthApiService,private fb:FormBuilder,private dialog:MatDialog,private feeService:FeeApiService) {
	}

	ngOnInit(): void {
		this.entityName = localStorage.getItem('entityName');
		this.entityGroup = JSON.parse(localStorage.getItem('entityGroup'));
		this.colourTheme  = localStorage.getItem('headerTheme');
		this.session = localStorage.getItem('session');
		this.qac = localStorage.getItem('qac');
		this.selectedSession = {
			name : localStorage.getItem('session'),
			startDate : localStorage.getItem('sessionStartDate'),
			endDate: localStorage.getItem('sessionEndDate')
		};
		this.browserDomain = this.service.browserDomain;
		this.userType = localStorage.getItem('userType');
		this.selectedEntity = this.entityId;
		document.getElementById('kt_header_mobile').style.backgroundColor = this.colourTheme;
		if(this.userType =='od2' || this.userType == 'od3'){
			this.listSession();
			}
			this.validateForm()

		this.filteredEntities.next(this.entityGroup ? this.entityGroup.slice() : []);

		this.entityFilterCtrl.valueChanges
			.pipe(takeUntil(this._onDestroy))
			.subscribe(() => {
				this.filterEntities();
			});
	}
	validateForm()
	{
		this.validationForm = this.fb.group({
			controlOTP:['',Validators.compose([
				Validators.required
			])],
			controlPasswd:['',Validators.compose([
				Validators.required
			])]
		})
		this.validationSwitchForm = this.fb.group({
			controlClient:['',Validators.compose([
				Validators.required
			])],

		})
	}

	logout() {
		const hasXToken = !!this.util.getCookie('x-token');
		const hasNoRedirect = !!this.util.getCookie('noRedirect');
		let userType = this.userType;
		let qac = this.qac;
		localStorage.removeItem('token');
		localStorage.removeItem('isExternalLogin');
		localStorage.removeItem('name')
		localStorage.removeItem('userType');
		localStorage.removeItem('session');
		localStorage.removeItem('mobile');
		localStorage.removeItem('sessionEndDate');
		localStorage.removeItem('sessionStartDate');
		localStorage.removeItem('entityType');
		localStorage.removeItem('entityId');
		localStorage.removeItem('homeEntityId');
		localStorage.removeItem('entityData');
		localStorage.removeItem('logo')
		localStorage.removeItem('entityName')
		localStorage.removeItem('primaryColour')
		localStorage.removeItem('entityGroup')
		localStorage.removeItem('permissions')
		localStorage.removeItem('secondaryColour')
		localStorage.removeItem('entityPreferences')
		localStorage.removeItem('userPreferences')
		localStorage.removeItem('qac')
		localStorage.removeItem('employee')
		localStorage.removeItem('employeeId')
		localStorage.removeItem('employeeType')
		localStorage.removeItem('layoutConfig');
		localStorage.removeItem('language');
		localStorage.removeItem('activeSessionStartDate');
		localStorage.removeItem('status');
		localStorage.removeItem('superSession');
		localStorage.removeItem('communicationSetup');
		localStorage.removeItem('tourStage')
		localStorage.removeItem('welcomeTour')
		localStorage.removeItem('admissionSource')
		localStorage.removeItem('deviceInfo')
		localStorage.removeItem('courseByTeacherData')
		localStorage.removeItem('courseByTeacherData');
        localStorage.removeItem('courseByTeacherDataDateWise');
		localStorage.removeItem('estimatedCollections');
		localStorage.removeItem('estimatedCollectionsDate');
		this.util.removeCookie('x-token');
		this.util.removeCookie('noRedirect');
		// localStorage.clear();
		if (hasXToken && !hasNoRedirect) {
			window.location.href = environment.extraMarksConfig.logout
		} else if(userType == 'od4'){
		this.router.navigate(['/auth/'+qac]);
		}else{
			this.router.navigate(['/auth/'+qac+'/staff'])
		}

	}

	removeControl(name: string): void {
		delete (this.validationSwitchForm.controls[name]);
	  }
	switchEntity(event,templateref)
	{
		this.selectedEntity = event;
		this.service.getEntityData(this.selectedEntity)
		.subscribe(res=>{
          if(!res.activeSession){
			this.setOtherValues(res)
            this.util.alertNotificationMessage('Please Activate A Session First');
		  setTimeout(() => {							
			window.location.href = this.browserDomain + '/academicSession';
		},);
		  return
          }else{
			this.selectedEntityData = res
			if(res.entityPreferences.clientAccessOTP){
				this.clientAccessOTPNumbers = res.entityPreferences.clientAccessOTPNumbers;
			this.showOTP = false;
			this.removeControl('controlOTP')
			this.selectedEntity = event
			this.selectedClient = undefined
			this.dialog.open(templateref,{width:'40%',disableClose:true});
			}else{
				this.moveToEntity(res)
			}

		  }
		  this.ref.detectChanges();
        //   window.location.href = this.browserDomain + '/entity/dashboard';
		},
		err=>{
		})
	}
	moveToEntity(res)
	{
					let entityData =res;

		  if(this.userPreference && this.userPreference.session){
            this.service.fetchSession(res._id,this.userPreference.session)
            .subscribe(data=>{
				this.setOtherValues(entityData)

			  setTimeout(() => {	
				localStorage.setItem('session', data.name);
				localStorage.setItem('superSession', data.superSession);
				localStorage.setItem('sessionStartDate', data.startDate);
				localStorage.setItem('sessionEndDate', data.endDate);						
				window.location.href = this.browserDomain + '/entity/dashboard';  
			},);
            },err=>{
				this.util.confirmAlert('Preferred session not found in this institute, switched to active session').subscribe((sure:boolean) => {
					if(sure){

						this.setOtherValues(entityData)
						setTimeout(() => {			
							localStorage.setItem('session', entityData.activeSession.name);
							localStorage.setItem('sessionStartDate', entityData.activeSession.startDate);
							localStorage.setItem('sessionEndDate', entityData.activeSession.endDate);
							localStorage.setItem('superSession', entityData.activeSession.superSession);				
							window.location.href = this.browserDomain + '/entity/dashboard';  
						},);
					}else{
						this.selectedEntity = this.entityId;
					  return
					}
				  })
            })
        }else{
			this.setOtherValues(res)
			setTimeout(() => {		
				localStorage.setItem('session', res.activeSession.name);
				localStorage.setItem('sessionStartDate', res.activeSession.startDate);
				localStorage.setItem('sessionEndDate', res.activeSession.endDate);
				localStorage.setItem('superSession', res.activeSession.superSession);					
				window.location.href = this.browserDomain + '/entity/dashboard';  
			},);       
        }
	}
	setOtherValues(res)
	{
		localStorage.removeItem('sessionEndDate');
		localStorage.removeItem('sessionStartDate');
		localStorage.removeItem('session');
		localStorage.removeItem('entityType');
		localStorage.removeItem('entityId');
		localStorage.removeItem('entityData');
		localStorage.removeItem('logo');
		localStorage.removeItem('qac');
		localStorage.removeItem('entityName');
		localStorage.removeItem('primaryColour');
		localStorage.removeItem('secondaryColour');
		localStorage.removeItem('entityPreferences');
		localStorage.removeItem('communicationSetup');
		localStorage.removeItem('superSession')
		localStorage.removeItem('courseByTeacherData')
        localStorage.removeItem('courseByTeacherDataDateWise');
		localStorage.setItem('entityId', res._id);

          localStorage.setItem('qac', res.qac);
          localStorage.setItem('logo', res.logo);
		  let entityData= {
			entityModules: res.entityModules,
			location : res.location,
			receptionNumber : res.receptionNumber,
			displayName: res.displayName,
			contactEmail: res.contactEmail,
			logo: res.logo,
			cbseAffiliationNumber:res.cbseAffiliationNumber,
		    cbseSchoolCode:res.cbseSchoolCode,
		    schoolId:res.schoolId,
			udiseId:res.udiseId,
			principal:res.principal,
			extraMarksEntity: res.extraMarksEntity
		  }
          localStorage.setItem('entityData', JSON.stringify(entityData))
          localStorage.setItem('entityPreferences', JSON.stringify(res.entityPreferences))
          if(res.entityPreferences && res.entityPreferences.secondaryColour){

			localStorage.setItem('secondaryColour', res.entityPreferences.secondaryColour);
		  }
          if(res.entityPreferences && res.entityPreferences.primaryColour){

			localStorage.setItem('primaryColour', res.entityPreferences.primaryColour);

			if(res.entityPreferences.primaryColour == '#ffffff' || res.entityPreferences.primaryColour == '#fff'){
				localStorage.setItem('primaryColour', '#1ca9c9');
			}
		  }
		  if(res.communicationSetup){
            localStorage.setItem('communicationSetup', JSON.stringify(res.communicationSetup))
          }
          localStorage.setItem('entityName', res.displayName)
          localStorage.setItem('entityType', res.entityType)
	}
	listSession(){

		let sortByTest = this.sortBy
		this.entityGroup.sort(function(a,b){
			if(isNaN(a[sortByTest])){
				  return (a[sortByTest].localeCompare(b[sortByTest]))
			}else{
			  return (a[sortByTest] - b[sortByTest])
			}
		})
		this.filteredEntities.next(this.entityGroup.slice());

		this.feeService.getSessionList(this.entityId)

		.subscribe(data => {
			 this.sessions = data;
			 this.util.arrayReverseSort(this.sessions,'startDate')
			 this.sessionData = data
			 this.ref.detectChanges();
		  },
		  err=>{
			this.util.errmsg(err);
		  });
	  }
	  compareObjects(o1: any, o2: any): boolean {
		return o1.name === o2.name;
	  }
	  toggalForggotPassword(){
		this.forggotPassword = !this.forggotPassword
	  }

	  activateSession(event){
		this.selectedSession = event;
		this.htmlClassService.setSessionName(this.selectedSession.name);
		localStorage.removeItem('session');
		localStorage.removeItem('superSession');
		  localStorage.removeItem('sessionStartDate');
		  localStorage.removeItem('sessionEndDate');
		  localStorage.removeItem('courseByTeacherData');
          localStorage.removeItem('courseByTeacherDataDateWise');
		  localStorage.setItem('session', this.selectedSession.name);
		  localStorage.setItem('superSession', this.selectedSession.superSession);
		  localStorage.setItem('sessionStartDate', this.selectedSession.startDate);
		  localStorage.setItem('sessionEndDate', this.selectedSession.endDate);
		  this.util.alertMessage('Session ', 'changed to '+this.selectedSession.name)
		//   window.location.reload();
		  this.util.redirect('redirect')
	  }	  

	  getOTP(){
		let mobile = localStorage.getItem('mobile')
		this.api.sendOtp(mobile)
		.subscribe(res=>{
		  this.util.alertMessage('OTP', 'Sent');
		  this.ref.detectChanges();
		  // this.resendOTPTimer();
		},
		err=>{
		  console.log(err);
		})
	  }
	  changePassword()
	  {

		let controls = this.validationForm.controls;
		if(this.validationForm.invalid)
		{
			Object.keys(controls).map(control=>{
				controls[control].markAsTouched()
			})

			return;
		}
		let formData:any={}
		formData.mobile = localStorage.getItem('mobile')
		formData.otp = this.otp
		formData.password = this.password
		formData.id = localStorage.getItem('userId')
		this.api.changePasswd(formData)
		.subscribe(res=>{
			this.util.alertSpecialMessage(res.message)
		},err=>{
			this.util.errmsg(err)
			this.ref.detectChanges()
		})
	  }
	  
	  getSwitchOTP(){
		let controls = this.validationSwitchForm.controls;
		if(this.validationSwitchForm.invalid)
		{
			Object.keys(controls).map(control=>{
				controls[control].markAsTouched()
			})

			return;
		}
		let mobile = this.selectedClient.number
		this.api.sendOtp(mobile)
		.subscribe(res=>{
			this.showOTP = true;
			this.validationSwitchForm.addControl('controlOTP', this.fb.control('', [Validators.required]));
		  this.util.alertMessage('OTP', 'Sent');
		  this.ref.detectChanges();
		  // this.resendOTPTimer();
		},
		err=>{
			this.showOTP = false
		})
	  }
	  submitOTP(){
		const controls = this.validationSwitchForm.controls;
		if (this.validationSwitchForm.invalid) {
		Object.keys(controls).forEach(controlName =>
			controls[controlName].markAsTouched()
			);
		return;
		}
		let  mobile = this.selectedClient.number;
		let  otp = this.enteredOTP;
		this.api.verifyOtp(mobile, otp, undefined)
		.subscribe(res=>{
			this.addUserLogs(mobile,otp)
		},err=>{
			this.util.errmsg(err);
			})
}
addUserLogs(mobile,otp)
{
	let formData:any={}
	formData.action= "entitySwitch",
    formData.module= "entitySwitch",
    formData.reqData = {mobile,otp},
    formData.userDetails = JSON.parse(localStorage.getItem('deviceInfo')),
    formData.entity=this.entityId
	this.service.addUserLogs(formData)
	.subscribe(res=>{
		this.moveToEntity(this.selectedEntityData)
		this.ref.detectChanges()
	},err=>{
		this.moveToEntity(this.selectedEntityData)
	})
}
closeTemplate()
{
	this.selectedEntity = this.entityId;
	this.dialog.closeAll()
}
	  isControlHasError(controlName:string,validationType:any):boolean{

		const control = this.validationForm.controls[controlName];
		if(!control)
		{
			return false;
		}
		const result = control.hasError(validationType) && (control.touched || control.dirty);
		return result

	  }

	  protected filterEntities() {
		if (!this.entityGroup) {
			return;
		}
		// get the search keyword
		let search = this.entityFilterCtrl.value;
		if (!search) {
			this.filteredEntities.next(this.entityGroup.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		// filter the entities
		this.filteredEntities.next(
			this.entityGroup.filter(item => item.name.toLowerCase().indexOf(search) > -1)
		);
	}

	ngOnDestroy() {
		this._onDestroy.next();
		this._onDestroy.complete();
	}
	  isControlSwitchHasError(controlName:string,validationType:any):boolean{

		const control = this.validationSwitchForm.controls[controlName];
		if(!control)
		{
			return false;
		}
		const result = control.hasError(validationType) && (control.touched || control.dirty);
		return result

	  }
	  
}
